import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const DocumentInvalidOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G fill={color} clipPath="url(#a)">
      <Path d="M14.65 9.075c-.017-.875-.05-1.75-.142-2.625-.216-1.675-1.941-3.483-3.616-3.717A20.933 20.933 0 0 0 4.6 2.95c-.917.183-1.833 1.142-1.992 2.058-.466 3-.466 6 0 9 .159.909 1.075 1.876 1.992 2.059a20.93 20.93 0 0 0 3.867.358c.475 0 .95-.033 1.433-.067.733.542 1.625.884 2.608.884a4.374 4.374 0 0 0 4.375-4.375c0-1.634-.908-3.042-2.233-3.792Zm-3.925-5.1c.792.117 1.683.85 2.175 1.667h-1.95a.224.224 0 0 1-.225-.225V3.975ZM8.9 10.125H6.367a.58.58 0 0 0-.584.584.58.58 0 0 0 .584.583h2.058a4.31 4.31 0 0 0-.308 1.575c0 .85.25 1.633.666 2.3-.108 0-.216.017-.325.017-1.208 0-2.425-.117-3.616-.334-.4-.083-.934-.633-1-1.025a27.561 27.561 0 0 1 0-8.6c.066-.408.6-.958.983-1.033a19.859 19.859 0 0 1 3.633-.342c.334 0 .675.008 1.009.033v1.55c0 .809.658 1.475 1.475 1.475h2.333c.05.567.092 1.125.117 1.692a4.332 4.332 0 0 0-4.308 1.583.649.649 0 0 0-.184-.033v-.025ZM12.5 16a3.126 3.126 0 0 1 0-6.25 3.126 3.126 0 0 1 0 6.25Z" />
      <Path d="M10.659 8.083a.58.58 0 0 0-.584-.583H6.167a.58.58 0 0 0-.583.583.58.58 0 0 0 .583.584h3.908a.58.58 0 0 0 .584-.584ZM14.333 11.325a.589.589 0 0 0-.825 0l-.9.9-.9-.9a.589.589 0 0 0-.825 0 .589.589 0 0 0 0 .825l.9.9-.9.9a.589.589 0 0 0 .417 1c.15 0 .3-.058.416-.175l.9-.9.9.9a.587.587 0 0 0 .834 0 .589.589 0 0 0 0-.825l-.9-.9.9-.9a.589.589 0 0 0 0-.825h-.017Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h20v20H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default DocumentInvalidOutlined
